import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './PersonalizedHeader.module.css';
import { MAX_NAME_LENGTH } from './types';
import { usePersonalizationTheme } from './usePersonalizationTheme';
export const PersonalizedHeader = ({ children }) => {
    const { theme, hasTheme } = usePersonalizationTheme();
    if (!hasTheme) {
        return null;
    }
    const displayName = theme?.headerLine1?.slice(0, MAX_NAME_LENGTH);
    return (_jsxs("header", { className: styles.container, "data-testid": 'personalized-header', children: [theme?.headerImage ? (_jsx("img", { src: theme.headerImage, alt: theme.headerLine1 ?? 'Logo do escritório', className: styles.logo, "data-testid": 'personalized-header-logo' })) : (_jsx("span", { className: styles.name, "data-testid": 'personalized-header-name', title: displayName, children: displayName })), children] }));
};
export default PersonalizedHeader;
